export class User {
    /**
     * ADM-813: `users.callingCode` crudo. Opcional y fuera del constructor a propósito: los `new User(...)`
     * posicionales de `AuthService` y `UserService` no lo traen, así que no es fuente de verdad. Solo lo
     * fija `UserService.patchSessionUser` tras confirmar un número nuevo.
     */
    callingCode?: string | null;

    constructor(
        public _id: string,
        public email: string,
        public name: string,
        public lastName: string,
        public tenantId: string,
        private _token: string,
        private _tokenExpirationDate: Date,
        public roles: string[],
        public phone: string,
        public birthday: Date,
        public location: string,
        public locations: string[],
        public enabled: boolean,
        public status: string,
        public permissions: any,
        public showNews: boolean,
        public instructionsNotToShow: string[],
        public salePreferences: any,
        // FINA-2062: gating del módulo Créditos en el frontend (sidebar + guard).
        // `creditAccess`: el tenant tiene al menos un Credito (admin se lo asignó).
        // `isOwner`: el user es owner del tenant (tenant.ownerId === user._id en el backend).
        // Opcionales por backwards-compat — los populan los responses de signIn / verified-user.
        public creditAccess: boolean = false,
        public isOwner: boolean = false,
        // Conteo de visualizaciones del modal de tutorial por módulo (límite de 3
        // apariciones automáticas). Opcional por backwards-compat — lo populan los
        // responses de signIn / verified-user; instructionsNotToShow no se altera.
        public instructionsViews: { [instructionsSetName: string]: number } = {},
    ) {}

    get token() {
        if (!this._tokenExpirationDate || new Date() > this._tokenExpirationDate) {
            return null;
        }
        return this._token;
    }

    get tokenExpirationDate() {
        return this._tokenExpirationDate;
    }
}
